<template>
  <div
    :class="[
      'side',
      isShow ? 'noexpand' : 'expand',
      { 'other-page': !is_home },
    ]"
  >
    <img
      v-if="isShow"
      class="arrow"
      src="../assets/images/side_right_arrow.png"
      @click="chageShow"
    />
    <img
      v-else
      class="arrow"
      src="../assets/images/side_left_arrow.png"
      @click="chageShow"
    />
    <div class="content" @click="chageShow">
      <div class="download">
        <img
          @click="go('https://www.facebook.com/GrandTrader')"
          src="../assets/images/fb_down.png"
        />
        <img @click="go('https://play.google.com/store/apps/details?id=com.gp.traderddj.en')" src="../assets/images/google_down.png" />
        <!-- <img src="../assets/images/apple_down.png" /> -->
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
      state: this.$store.state,
      // m: false,
      // android: true,
    };
  },
  computed: {
    cur_route() {
      return this.state.currentRoute;
    },

    // 是否在首页
    is_home() {
      return this.cur_route == "Home";
    },
  },
  methods: {
    chageShow() {
      this.isShow = !this.isShow;
    },

    go(url) {
      window.open(url);
    },
    // isPhone() {
    //   var userAgentInfo = navigator.userAgent;
    //   var Agents = new Array(
    //     "Android",
    //     "iPhone",
    //     "SymbianOS",
    //     "Windows Phone",
    //     "iPad",
    //     "iPod"
    //   );
    //   var flag = false;
    //   for (var v = 0; v < Agents.length; v++) {
    //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
    //       flag = true;
    //       break;
    //     }
    //   }
    //   return flag;
    // },
    // isAndroid() {
    //   var u = navigator.userAgent;
    //   var ua = u.toLowerCase();
    //   if (/iphone|ipad|ipod/.test(ua)) {
    //     return false;
    //   } else if (/android/.test(ua)) {
    //   }
    //   return true;
    // },
  },
};
</script>
<style scoped lang="scss">
@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
}

@keyframes noexpand {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(70%);
  }
}
@keyframes expand {
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(0);
  }
}

@media screen and (max-width: 768px) {
  .side {
    display: none;
  }
}

.side {
  position: fixed;
  width: 290px;
  height: 680px;
  top: calc(50% - 340px);
  right: 0;
  z-index: 1000;
  transform: translatey(0px);
  animation: float 3s ease-in-out infinite;
  &.other-page {
    position: absolute;
    top: 330px;
  }
  &.noexpand {
    //收起
    animation: expand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }
  &.expand {
    //展开
    animation: noexpand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }
  > .arrow {
    cursor: pointer;
    position: absolute;
    top: 240px;
    right: 60px;
    width: 181px;
    height: 54px;
  }
  > .content {
    width: 290px;
    height: 649px;
    background-image: url(../assets/images/side_full.png);
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    > .download {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 12px;
      bottom: 168px;
      height: 200px;
      > img {
        width: 164px;
        // height: 44px;
        opacity: 0.9;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          opacity: 1;
        }
      }
    }
    > .qrcode {
      position: absolute;
      bottom: 110px;
      right: 12px;
      width: 143px;
      height: 143px;
      > img {
        width: 143px;
        height: 143px;
      }
      > .light-line {
        position: absolute;
        top: 50%;
        left: 0;
        width: 144px;
        height: 10px;
        transform: translatey(0px);
        animation: floatLine 3s ease-in-out infinite;
      }
    }
  }
}
</style>